if (!customElements.get('cart-notification')) {
  class CartNotification extends HTMLElementLazyInit {
    constructor() {
      super();
      this.isInitialized = false;
      this.dismissTimer = null;
      this.dismissDelay = 6000;
      this.isPointerInside = false;
      this.isFocusInside = false;
    }

    init() {
      if (this.isInitialized) return;

      this.isInitialized = true;
      window.loadTemplateContent(this);

      requestAnimationFrame(() => {
        this.notification = document.getElementById('cart-notification');
        this.header = document.querySelector('sticky-header');
        this.cartDrawer = document.querySelector('cart-drawer');
        this.viewCartButton = this.querySelector('.js-view-cart');

        if (!this.notification) return;

        this.notification.addEventListener('keyup', (event) => {
          if (event.code === 'Escape') this.close();
        });
        this.notification.addEventListener('pointerenter', () => {
          this.isPointerInside = true;
          this.pauseDismiss();
        });
        this.notification.addEventListener('pointerleave', () => {
          this.isPointerInside = false;
          this.resumeDismiss();
        });
        this.notification.addEventListener('focusin', () => {
          this.isFocusInside = true;
          this.pauseDismiss();
        });
        this.notification.addEventListener('focusout', (event) => {
          if (event.relatedTarget && this.notification.contains(event.relatedTarget)) return;
          this.isFocusInside = false;
          this.resumeDismiss();
        });
        this.viewCartButton?.addEventListener('click', this.handleViewCartClick.bind(this));
        this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
          closeButton.addEventListener('click', this.close.bind(this))
        );
        this.cartOpenUnsubscriber = subscribe(PUB_SUB_EVENTS.cartOpen, () => this.close());
      });
    }

    disconnectedCallback() {
      this.pauseDismiss();
      this.cartOpenUnsubscriber?.();
    }

    open() {
      if (theme.settings.cartDrawer.muteNotification || !this.notification) return;

      this.notification.classList.add('animate', 'active');
      this.notification.removeAttribute('aria-hidden');
      this.scheduleDismiss();
    }

    close() {
      if (!this.notification) return;

      this.pauseDismiss();
      this.notification.classList.remove('active');
      this.notification.setAttribute('aria-hidden', 'true');
    }

    scheduleDismiss() {
      this.pauseDismiss();
      if (!this.notification?.classList.contains('active') || this.isPointerInside || this.isFocusInside) return;

      this.dismissTimer = setTimeout(() => this.close(), this.dismissDelay);
    }

    pauseDismiss() {
      if (this.dismissTimer === null) return;
      clearTimeout(this.dismissTimer);
      this.dismissTimer = null;
    }

    resumeDismiss() {
      if (this.isPointerInside || this.isFocusInside) return;
      this.scheduleDismiss();
    }

    renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section) => {
        const target = document.getElementById(section.id);
        const sectionHtml = parsedState.sections?.[section.id];
        if (!target || !sectionHtml) return;
        target.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
      });

      if (theme.settings.cartDrawer.atcAction === 'notification' && !this.cartDrawer?.classList.contains('active')) {
        this.header?.reveal();
        this.open();
      }
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-notification-product',
          selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
        },
        {
          id: 'cart-notification-button',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const normalized = html.replace(/<template\b[^>]*>|<\/template>/g, '');
      return new DOMParser().parseFromString(normalized, 'text/html').querySelector(selector)?.innerHTML || '';
    }

    handleViewCartClick(event) {
      if (!this.cartDrawer) return;

      event.preventDefault();
      this.close();
      this.cartDrawer.open(event.currentTarget);
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-notification', CartNotification);
}
